var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 336,
    height: 335,
    viewBox: "0 0 336 335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellisse_116",
    x: 0,
    y: 0,
    width: 336,
    height: 335,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_117",
    cx: 159,
    cy: 158.5,
    rx: 159,
    ry: 158.5,
    transform: "translate(0.059)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Ellisse_116)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_116-2",
    cx: 159,
    cy: 158.5,
    rx: 159,
    ry: 158.5,
    transform: "translate(9 8)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_4",
    transform: "translate(8.941 6)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-user-5506653",
    transform: "translate(39.583 53.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_249",
    d: "M131.442,258.2v7.688a12.779,12.779,0,0,0,3.752,9.031l.254.27a12.752,12.752,0,0,0,8.779,3.49H334.515a12.726,12.726,0,0,0,9.031-3.735,12.86,12.86,0,0,0,3.752-9.049V258.2c0-50.519-27.873-82.823-63.547-96.926a122.931,122.931,0,0,0-88.782-.008c-35.666,14.11-63.537,46.408-63.537,96.926ZM239.374,14.58a57.055,57.055,0,1,1-40.351,16.711l.357-.323A56.867,56.867,0,0,1,239.374,14.58Zm32.131,24.933a45.478,45.478,0,0,0-63.983-.286l-.28.3a45.428,45.428,0,1,0,64.27-.01ZM119.811,265.88v-7.688c0-56.078,31.1-92,70.892-107.735a134.509,134.509,0,0,1,97.32,0c39.8,15.733,70.9,51.661,70.9,107.735v7.688A24.461,24.461,0,0,1,334.508,290.3H144.22a24.35,24.35,0,0,1-16.877-6.815l-.375-.341a24.356,24.356,0,0,1-7.164-17.253Z",
    transform: "translate(-119.803 -14.58)",
    fill: "#7d6eb1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/defaultAvatar.6604f7da1527a6f349d8da0c9a25ad85.svg";
export { ForwardRef as ReactComponent };